import { lazy } from 'react'
import { LazyWrapper, LazyErrorBoundary } from '../components/LazyWrapper'

// Enhanced lazy load all admin pages
export const LazyDashboard = lazy(
  () => import('../pages/Dashboard/AdminDashboard').then(module => ({ 
    default: module.default 
  }))
)

export const LazyPackages = lazy(
  () => import('../pages/Packages/AdminPackages').then(module => ({ 
    default: module.default 
  }))
)

export const LazyAllPackages = lazy(
  () => import('../pages/Packages/AllPackages').then(module => ({ 
    default: module.default 
  }))
)

export const LazyArchivedPackages = lazy(
  () => import('../pages/Packages/ArchivedPackages').then(module => ({ 
    default: module.default 
  }))
)

export const LazyExpiredPackages = lazy(
  () => import('../pages/Packages/ExpiredPackages').then(module => ({ 
    default: module.default 
  }))
)

export const LazyDeletedPackages = lazy(
  () => import('../pages/Packages/DeletedPackages').then(module => ({ 
    default: module.default 
  }))
)

export const LazyVisaApplications = lazy(
  () => import('../pages/VisaApplications/AdminVisaApplications').then(module => ({ 
    default: module.default 
  }))
)

export const LazyTravelInsurance = lazy(
  () => import('../pages/TravelInsurance/TravelInsurance').then(module => ({ 
    default: module.default 
  }))
)

export const LazyTestimonials = lazy(
  () => import('../pages/Testimonials/AdminTestimonials').then(module => ({ 
    default: module.default 
  }))
)

export const LazySettings = lazy(
  () => import('../pages/Settings/AdminSettings').then(module => ({ 
    default: module.default 
  }))
)

export const LazyAdminLogin = lazy(
  () => import('../pages/Login/AdminLogin').then(module => ({ 
    default: module.default 
  }))
)

// Wrapper components with error boundaries and custom loading states
export const Dashboard = () => (
  <LazyErrorBoundary>
    <LazyWrapper skeleton message="Loading dashboard...">
      <LazyDashboard />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const Packages = () => (
  <LazyErrorBoundary>
    <LazyWrapper skeleton message="Loading packages...">
      <LazyPackages />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const AllPackages = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading all packages...">
      <LazyAllPackages />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const ArchivedPackages = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading archived packages...">
      <LazyArchivedPackages />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const ExpiredPackages = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading expired packages...">
      <LazyExpiredPackages />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const DeletedPackages = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading deleted packages...">
      <LazyDeletedPackages />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const VisaApplications = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading visa applications...">
      <LazyVisaApplications />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const TravelInsurance = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading travel insurance applications...">
      <LazyTravelInsurance />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const Testimonials = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading testimonials...">
      <LazyTestimonials />
    </LazyWrapper>
  </LazyErrorBoundary>
)

export const Settings = () => (
  <LazyErrorBoundary>
    <LazyWrapper message="Loading settings...">
      <LazySettings />
    </LazyWrapper>
  </LazyErrorBoundary>
)